import { z } from 'zod'

export const PurchaseSchema = z.object({
	id: z.number(),
	quantity: z.number()
})

export type Purchase = z.infer<typeof PurchaseSchema>
